import React from 'react'

import { Container } from '@mui/joy'

import i18n from '@/i18n'

export default function DiscoveryModePage() {
  return (
    <Container>
      <h3>{i18n.t('discovery-mode')}</h3>
    </Container>
  )
}